import React, { useEffect, useState } from "react";
import ProfileSection from "../../components/profile/ProfileSection";
import ProjectDetailsCard from "../../components/project/ProjectDetailsCard";
import Loading from "../../components/Loading";
import { CheckIcon } from "@heroicons/react/solid";
import { fetchData } from "./api-handlers";
import routes from "../../config/routes-config.js";

const ListOfProjects = ({ data, type }) => {
  return data.completedProjectCardModel
    .filter((project) => type === "All" || project.projectType === type)
    .map((project) => (
      <div key={project.id} className="mb-6">
        <ProjectDetailsCard projectData={project} pageType="profile" />
      </div>
    ));
};

const GuidedProjects = ({ role }) => {
  const [projectsData, setprojectsData] = useState(null);
  const typeList = ["All", "EDAI", "SDP"];
  const [currentType, setType] = useState(typeList[0]);

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("auth"));
    let url;
    if (user !== null) {
      if (role === "teacher")
        url =
          routes.teacher.guidedProjects.guidedProjectsUrl +
          "?teacherUsername=" +
          user.userName;
      else if (role === "student")
        url =
          routes.student.completedProjects.completedProjectsUrl +
          "?studentUsername=" +
          user.userName;
      fetchData(url, setprojectsData, user.token);
    }
  }, [role]);

  return (
    <>
      {projectsData ? (
        <div className="flex flex-row py-8 px-10 w-full">
          <div>
            <ProfileSection
              profileData={projectsData}
              pageType="profile"
              role={role}
            />
          </div>
          <div className="flex-grow">
            <div className="flex flex-col ml-5 py-5 px-16 h-[calc(100vh-4rem)] bg-[#f2f2fd] rounded-xl">
              <div className="flex flex-row justify-between place-items-center">
                <h1 className="text-3xl text-[#1E1E4A] font-semibold">
                  {role === "teacher" ? "Guided " : "Completed "}Projects
                </h1>
                <div className="mr-5">
                  <div className="pr-8 group">
                    <div className="group-hover:block inline-block relative">
                      <button className="bg-gray-300 text-gray-700 font-semibold py-2 px-4 rounded inline-flex items-center w-24">
                        <span className="mr-1">Type</span>
                        <svg
                          className="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />{" "}
                        </svg>
                      </button>
                      <ul className="group-hover:block absolute hidden text-gray-700 pt-1 w-24">
                        {typeList.map((type, index) => (
                          <li key={index}>
                            <button
                              className="bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap w-24"
                              onClick={() => setType(typeList[index])}
                            >
                              <div className="flex flex-row justify-between place-items-center">
                                {type}
                                {type === currentType && (
                                  <CheckIcon className="h-4 fill-green-700" />
                                )}
                              </div>
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col overflow-y-scroll mt-10">
                <ListOfProjects data={projectsData} type={currentType} />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default GuidedProjects;
